import object from 'helpers/object'


export const initialState = {
  isFetching: false,
  schools: [],
}

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)

export const setSchools = (state, payload) => (
  object.setIn(state, [ 'schools' ], payload)
)
